<template>
    <div class="card">
        <h1 class="card-header text-center">Contact Information</h1>
        <div class="card-body">
            <form @submit.prevent="submit">
                <h3>A contact with this email already exists: {{searchEmail}}</h3>
                <p>If a contact below is the same person you need, please select it.
                If you do not see the correct contact data, please click on, Add a new contact.</p>
                <div class="form-row border">
                    <div class="col-lg-9">
                        <div class="form-group">
                        Barb Johnson, barb@statefarm.com, State Farm, 952-952-9523 Ext 2, 123 State Farm Way,
                        Minneapolis, MN, 55405, Hennepin, Fax: none, <strong>Supervisor: </strong> Martha Smith,
                        martha@statefarm.com, Agent Supervisor, 952-952-9521
                        </div>
                    </div>
                    <div class="col-lg-1" >
                        <div class="vertical-center"> <b-button variant="primary" v-on:click="selectData">Select</b-button></div>
                    </div>
                </div>
                <div style="padding-top: 10px"> <b-button variant="primary" v-on:click="submit">Add a new person</b-button></div>
            </form>
        </div>
    </div>
</template>

<script>

    import { required, minLength, email  } from 'vuelidate/lib/validators'

    export default {
        name: 'Search',
        data() {
            return {
                searchEmail: 'barb@statefarm.com',
                hasError: false
            }
        },
        validations: {
            searchEmail: {
                required, minLength: minLength(1), email
            }
        },
        methods: {

            validationStatus: function(validation) {
                return typeof validation != "undefined" ? validation.$error : false;
            },

            submit() {
                    window.location.replace('/contact');
            },
            selectData() {
                    window.location.replace('/contact');
                }
            }
    }

</script>

<style>
    .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    }

</style>